(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection--dual-slider"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll('.dual-slider-swiper').forEach(function(el) {
        new Swiper(el, {
          direction: 'horizontal',
          slidesPerView: 1,
          spaceBetween: 12,
          loop: true,
          navigation: {
            nextEl: el.querySelector('.dual-slider-next'),
            prevEl: el.querySelector('.dual-slider-prev'),
          },
          breakpoints: {}
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
